import Octicon from '../components/Octicon.vue'

Octicon.register({"x":{"width":12,"height":16,"d":"M7.48 8l3.75 3.75-1.48 1.48L6 9.48l-3.75 3.75-1.48-1.48L4.52 8 .77 4.25l1.48-1.48L6 6.52l3.75-3.75 1.48 1.48z"}})
